import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { browserHistory } from 'react-router';
import ProgressBar from './../../../../../components/ZUILib/ProgressBar';
import ApplyCss from './../../../../../components/ApplyCSS';
import commonUtil from '../../../../../utils/commonUtil';
import serverClientUtil from '../../../../../utils/serverClientUtil';
import * as labelsActions from '../../../../../components/labels/actions';
import { handleGetClosingGiftPriceRange, handleGetGiftClosingDetails } from './actions';
// import { handleGetGiftClosingDetails } from '../GiftOpening/actions';
import * as defaultConst from '../../../../../utils/clientConstant';
import Link from '../../../../../components/ZUILib/Link';
import Tagging from '../../../../../components/Tagging/Tagging';


const pageName = 'closureGift';
const channel = commonUtil.getChannel();

@connect(store => ({
  lables: store.labels.data,
  error: store.labels.error,
  loading: store.labels.loading,
  extraData: store.labels.extraData,
  globleObj: store.globleObject,
}),
  { ...labelsActions })

class ClosureGift extends Component {
  constructor(props) {
    super(props);
    this.progressWidth = parseInt(350, 10);
    this.callSecondServiceOfGetClosingDetailsService = false;
  }

  UNSAFE_componentWillMount() {
    const eventID = this.props.params && this.props.params.eventID ? this.props.params.eventID : null;
    if (eventID) {
      this.props.handleGetGiftClosingDetails(eventID);
    }
  }

  componentDidMount() {
    const eventUrl = 'gestiondeeventos/RegaloPorCierre/';
    // eslint-disable-next-line no-undef
    dataLayer.push({
      event: 'vPageView',
      GroupOne: eventUrl,
      actURL: window.location.pathname,
      actPageTitle: document.title,
      cdSection: 'Regalo por Cierre',
      Site: 'Mesa de Regalos',
      idMesa: this.eventID,
    });
    if (!this.props.user) {
      browserHistory.push('/');
    }
    if (this.props.user &&
      this.props.user.result &&
      this.props.user.result.status.status === defaultConst.constAPIFailure) {
      browserHistory.push('/');
    }
    if (this.props.params && !this.props.params.eventID) {
      browserHistory.push('/');
    }
    const eventID = this.props.params && this.props.params.eventID ? this.props.params.eventID : null;
    if (eventID) {
      this.props.handleGetClosingGiftPriceRange(eventID);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!commonUtil.isObjectEmpty(nextProps.closingGiftPriceRange)) {
      const required = nextProps.closingGiftPriceRange.requiredGiftAmountTotal;
      const current = nextProps.closingGiftPriceRange.currentGiftAmountTotal;
      const eventID = nextProps.params && nextProps.params.eventID ? nextProps.params.eventID : null;
      if (+required === +current && !this.callSecondServiceOfGetClosingDetailsService) {
        this.callSecondServiceOfGetClosingDetailsService = true;
        nextProps.handleGetGiftClosingDetails(eventID);
      }
    }
  }

  createProgressBar = (currentAmmount, max) => {
    const per = parseInt((currentAmmount * 100) / max, 10);
    return per;
  }

  webData = () => {
    const { lables, closingGiftPriceRange, closingGiftDetails } = this.props;
    // const deliveryMethodSelected = closingGiftDetails && closingGiftDetails.openingGiftDetailsForEventInfo.alreadySelected === 'true' && true;
    const fixedNumber = number => Number.parseFloat(number).toFixed(2);
    const pedidoNumber =
      closingGiftDetails && closingGiftDetails.openingGiftDetailsForEventInfo &&
        closingGiftDetails.openingGiftDetailsForEventInfo.pedidoNumber ?
        closingGiftDetails.openingGiftDetailsForEventInfo.pedidoNumber : null;
    const trackingUrl =
      closingGiftDetails && closingGiftDetails.openingGiftDetailsForEventInfo &&
        closingGiftDetails.openingGiftDetailsForEventInfo.url ?
        closingGiftDetails.openingGiftDetailsForEventInfo.url : null;
    const storeName =
      closingGiftDetails && closingGiftDetails.openingGiftDetailsForEventInfo &&
        closingGiftDetails.openingGiftDetailsForEventInfo.storeName ?
        closingGiftDetails.openingGiftDetailsForEventInfo.storeName : null;
    const skuSelected =
      closingGiftDetails && closingGiftDetails.openingGiftDetailsForEventInfo &&
        closingGiftDetails.openingGiftDetailsForEventInfo.skuInfo ?
        closingGiftDetails.openingGiftDetailsForEventInfo.skuInfo : null;
    const ownerNickName =
      closingGiftDetails && closingGiftDetails.openingGiftDetailsForEventInfo &&
        closingGiftDetails.openingGiftDetailsForEventInfo.selectedCelebrityName ?
        closingGiftDetails.openingGiftDetailsForEventInfo.selectedCelebrityName : null;
    const alreadySelected =
      closingGiftDetails && closingGiftDetails.openingGiftDetailsForEventInfo &&
        closingGiftDetails.openingGiftDetailsForEventInfo.alreadySelected ?
        closingGiftDetails.openingGiftDetailsForEventInfo.alreadySelected : null;
    const maxValue = +closingGiftPriceRange.requiredGiftAmountTotal;
    const currentAmmount = (+closingGiftPriceRange.currentGiftAmountTotal);
    const preleftAmount = (+closingGiftPriceRange.requiredGiftAmountTotal) - (+closingGiftPriceRange.currentGiftAmountTotal);
    const leftAmount = fixedNumber(preleftAmount);
    const progress = this.createProgressBar(currentAmmount, maxValue);


    return (
      <div className="col-md-9 addressIntro">
        <ApplyCss pageName={pageName} />
        <Tagging ref={tagging => this.tagging = tagging} />
        <h1 className="titleSection">Regalo por cierre</h1>
        {/* {(!alreadySelected && (!pedidoNumber || (!ownerNickName && !storeName))) ? */}
        {alreadySelected === 'false' ?
          <React.Fragment>
            <p className="descriptiveText">{commonUtil.getLabel(lables.editEventClosingGift, 'editEventClosingGift.closing.granted.time.message1')} ${maxValue}</p>
            <p className="descriptiveText">{commonUtil.getLabel(lables.editEventClosingGift, 'editEventClosingGift.closing.granted.time.message2')}</p>

            {/* when the amount of purchase reached the Threshold limit  */}
            {leftAmount < 1 ?
              // <p className="mainTextSecond">Monto acumulado: <span>{'$' + 0}</span></p> :
              <p className="mainTextSecond">Monto faltante para regalo por cierre: <span>{'$' + 0}</span></p> :
              <p className="mainTextSecond">Monto faltante para regalo por cierre: <span>{'$' + leftAmount}</span></p>
            }
            <div className="progress">
              <ProgressBar width={350} height={5} percent={progress} />
            </div>
            <div className="progressData">
              <p className="minData">$0</p>
              <p className="maxData">{'$' + maxValue}</p>
            </div>
          </React.Fragment>
          : <React.Fragment>
            <div className="selectedOptionsNow">
              <p className="mainText">Regalo: {(skuSelected && skuSelected.length) ? skuSelected.map((sku, ind) => <span key={ind}>
                {ind !== skuSelected.length - 1 ? sku.skuName + ', ' : sku.skuName}</span>) : null}
              </p>
              <p className="mainText"><span>Entrega a domicilio: {ownerNickName || storeName}</span></p>
            </div>
          </React.Fragment>
        }
        {leftAmount < 1 && !pedidoNumber && alreadySelected === 'false' ?
          <div className="fullProgressMessage">
            <p>¡FELICIDADES HAS LOGRADO ACUMULAR EL MONTO PARA TU REGALO POR CIERRE!</p>
            <p>{lables && commonUtil.getLabel(lables.editEventClosingGift, 'editEventClosingGift.closing.delivery.mode.message')}</p>
          </div>
          : null
        }
        {leftAmount < 1 && pedidoNumber && alreadySelected === 'true' ?
          <React.Fragment>
            <hr />
            <div className="selesctedGift">
              <h2 className="subtitleModule">Regalo enviado</h2>
              <h2 className="subtitleModule">No. de pedido: {pedidoNumber}</h2>
            </div>
            {/* <p className="mainText">{lables && commonUtil.getLabel(lables.editEventOpeningGfit, 'editEventOpeningGfit.delivery.status.message')}</p> */}
            <Link
              isNotSamePage
              linkJSON={{ href: serverClientUtil.getLPURL() + (trackingUrl.replace('.jsp', '')) + '?SearchOrder=true&TrackingNo=' + pedidoNumber, id: pedidoNumber, cssClass: 'primaryColorLink' }}
            >
              Ver status de entrega
              <i className="icon-flecha_gruesa_derecha" />
            </Link>
          </React.Fragment> : null
      }
      </div>
    );
  }

  wapData = () => {
    const { minValue, lables, closingGiftPriceRange, closingGiftDetails } = this.props;
    const fixedNumber = number => Number.parseFloat(number).toFixed(2);
    const pedidoNumber = closingGiftDetails ? closingGiftDetails.openingGiftDetailsForEventInfo.pedidoNumber : null;
    const trackingUrl = closingGiftDetails ? closingGiftDetails.openingGiftDetailsForEventInfo.url : null;
    const storeName = closingGiftDetails ? closingGiftDetails.openingGiftDetailsForEventInfo.storeName : null;
    const skuSelected = closingGiftDetails ? closingGiftDetails.openingGiftDetailsForEventInfo.skuInfo : null;
    const ownerNickName = closingGiftDetails ? closingGiftDetails.openingGiftDetailsForEventInfo.selectedCelebrityName : null;
    const alreadySelected = closingGiftDetails ? closingGiftDetails.openingGiftDetailsForEventInfo.alreadySelected : null;
    const maxValue = +closingGiftPriceRange.requiredGiftAmountTotal;
    const currentAmmount = (+closingGiftPriceRange.currentGiftAmountTotal);
    const preleftAmount = (+closingGiftPriceRange.requiredGiftAmountTotal) - (+closingGiftPriceRange.currentGiftAmountTotal);
    const leftAmount = fixedNumber(preleftAmount);
    const progress = this.createProgressBar(currentAmmount, maxValue);
    return (
      <div className="myEventContent row">
        {/* <div className="row"> */}
        <div id="closingGiftManagement" className="closureContainer">
          <ApplyCss pageName={pageName} />
          <div className="col-xs-12">
            <h1 className="noBorder">Regalo por cierre</h1>
          </div>
          {/* {(!pedidoNumber || (!ownerNickName && !storeName)) ?  */}
          {alreadySelected === 'false' ?
            <React.Fragment>
              <div className="col-xs-12">
                <h2 className="subtitleModule">
                  {commonUtil.getLabel(lables.editEventClosingGift, 'editEventClosingGift.closing.granted.time.message1')}
                  ${maxValue} {commonUtil.getLabel(lables.editEventClosingGift, 'editEventClosingGift.closing.granted.time.message2')}
                </h2>
                {leftAmount < 1 ?
                  // <p className="mainTextSecond">Monto acumulado: <span>{'$' + 0}</span></p> :
                  <p className="mainTextSecond">Monto faltante para regalo por cierre: <span>{'$' + 0}</span></p> :
                  <p className="mainTextSecond">Monto faltante para regalo por cierre: <span>{'$' + leftAmount}</span></p>
                }
              </div>
              <div className="col-xs-12">
                {/* <p className="amountGift2"> <span>{'$' + leftAmount}</span><span className="sr-only">{progress + '% Complete'}</span></p> */}
                <div className="progress">
                  <ProgressBar width={350} height={5} percent={progress} />
                </div>
              </div>
              <div className="col-xs-12">
                <div className="progressData">
                  <p className="minData">{'$' + minValue}</p>
                  <p className="maxData">{'$' + maxValue}</p>
                </div>
              </div>
            </React.Fragment>
            :
            <React.Fragment>
              <div className="selectedOptionsNow">
                <p className="mainText">Regalo: {(skuSelected && skuSelected.length) ? skuSelected.map((sku, ind) => <span key={ind}>
                  {ind !== skuSelected.length - 1 ? sku.skuName + ', ' : sku.skuName}</span>) : null}
                </p>
                <p className="mainText">Entrega a domicilio: <span>{ownerNickName || storeName}</span></p>
              </div>
            </React.Fragment>
          }

          {leftAmount < 1 && !pedidoNumber && alreadySelected === 'false' ?
            <div className="col-xs-12">
              <div className="fullProgressMessage">
                <p>¡FELICIDADES HAS LOGRADO ACUMULAR EL MONTO PARA TU REGALO POR CIERRE!</p>
                <p>{commonUtil.getLabel(lables.editEventClosingGift, 'editEventClosingGift.closing.delivery.mode.message')}</p>
              </div>
            </div>
            : null
          }
          {leftAmount < 1 && pedidoNumber && alreadySelected === 'true' ?
            <React.Fragment>
              <hr />
              <div className="selesctedGift">
                <h2 className="subtitleModule">Regalo enviado</h2>
                <h2 className="subtitleModule">No. de pedido: {pedidoNumber}</h2>
              </div>
              {/* <p className="mainText">{lables && commonUtil.getLabel(lables.editEventOpeningGfit, 'editEventOpeningGfit.delivery.status.message')}</p> */}
              <Link
                isNotSamePage
                linkJSON={{ href: serverClientUtil.getLPURL() + (trackingUrl.replace('.jsp', '')) + '?SearchOrder=true&TrackingNo=' + pedidoNumber, id: pedidoNumber, cssClass: 'primaryColorLink' }}
              >
                Ver status de entrega
                <i className="icon-flecha_gruesa_derecha" />
              </Link>
            </React.Fragment> : null
          }
        </div>
        {/* </div> */}
      </div>
    );
  }
  render() {
    if (this.props.closingGiftPriceRange) {
      return (
        channel === 'web' ? this.webData() : this.wapData()
      );
    }
    return null;
  }
}

ClosureGift.defaultProps = { minValue: 0 };
const mapStateToProps = state => ({
  lables: state.labels.data,
  closingGiftPriceRange: state.closingGiftPriceRange ? state.closingGiftPriceRange.closingGiftPriceRangeInfo : null,
  user: state.user.data,
  closingGiftDetails: state.closingGiftPriceRange && state.closingGiftPriceRange.closingGiftDetails ? state.closingGiftPriceRange.closingGiftDetails : null,
});
const matchDispatchToProps = dispatch => bindActionCreators({ handleGetClosingGiftPriceRange, handleGetGiftClosingDetails }, dispatch);
export default connect(mapStateToProps, matchDispatchToProps)(ClosureGift);

